var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      staticClass: "c-form",
      attrs: {
        action: _vm.autocompleteUrl,
        method: "get",
        "accept-charset": "utf-8",
      },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.search.apply(null, arguments)
        },
      },
    },
    [
      _c("i", { staticClass: "ico ico-search" }),
      _vm._v(" "),
      _c("div", { staticClass: "c-form__item c-form__item--text" }, [
        _c("input", {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.keyword,
              expression: "keyword",
            },
          ],
          ref: "searchInput",
          class: {
            "c-form__input": true,
            "is-empty": !_vm.keyword,
            "is-open": _vm.isOpen,
          },
          attrs: {
            type: "text",
            id: "autocomplete-" + parseInt(Math.random() * 1000),
            name: "search",
            autocomplete: "off",
            placeholder: _vm.inputPlaceholder,
          },
          domProps: { value: _vm.keyword },
          on: {
            input: [
              function ($event) {
                if ($event.target.composing) return
                _vm.keyword = $event.target.value
              },
              _vm.search,
            ],
            focus: _vm.showForm,
            keyup: function ($event) {
              if (
                !$event.type.indexOf("key") &&
                _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
              )
                return null
              return _vm.redirectToSearch.apply(null, arguments)
            },
          },
        }),
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "c-btn c-btn--primary is-search",
          class: {
            "is-loading": _vm.isLoading,
            "is-open": _vm.isOpen,
          },
          attrs: { href: _vm.searchUrl },
        },
        [
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("Autocomplete.Header.search")) +
              "\n    "
          ),
        ]
      ),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "c-btn is-close",
          class: {
            "is-loading": _vm.isLoading,
            "is-open": _vm.isOpen,
          },
          attrs: { type: "button" },
          on: { click: _vm.hideForm },
        },
        [
          _c("i", {
            staticClass: "ico ico-close-thin",
            attrs: { "aria-hidden": "true" },
          }),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }